import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['pwField']

  toggle () {
    if (this.pwFieldTarget.type === 'password') {
      this.pwFieldTarget.type = 'text'
    } else {
      this.pwFieldTarget.type = 'password'
    }
  }
}
